import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"


import Seo from "../components/SEO"
import "../styles/new.css"
import "../styles/mobilenew.css"
import im1 from "../images/bh/wvex1.jpg"

const WhiteVille = () => {



    return (
        <>
            <Seo
                title="White Ville"
                description="A case study of luxurious remake of white ville."
                image={im1}
            />

            <div className="section">
                <h3 className="centerthis">WHITE VILLA</h3>
            </div>


            <div className="section">

                <StaticImage placeholder="dominantColor" className="image maxdim" src="../images/bh/wvex1.jpg" alt="wvex1" />
            </div>



            <div className="centerthis casestudytestimonial">
                <article className="article">
                    <p>" Working with Karen and the Nolan Interiors team, is working with glamour,
                        responsibility, and commitment. They will work with your needs and help you
                        going through the transition of renovating your home. "</p>
                    <h4>Mr. & Mrs. Simpsons </h4>
                </article>

            </div>


            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="ltop"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h1.jpg" alt="wvex1" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article ">

                            <p>The white villa was constructed about two decades earlier as an epitome of luxury and className for the first family that lived here. </p>
                        </article>
                    </div>


                    <div className="rbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h2.jpg" alt="wvex1" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The place in itself had retained its charm thanks to the classNameical reflections evident there through its decor and choice of furniture.</p>
                        </article>
                    </div>



                </div>
            </div>



            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="rtop"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h3.jpg" alt="wvex1" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The aim was to turn this around and create a minimalist, modern place with a hint of glamour.</p>
                        </article>
                    </div>

                    <div className="lbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h4.jpg" alt="wvex1" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>We started out by getting rid of the maximalist elements and decor first, down to stripping away the grand chandelier.</p>
                        </article>
                    </div>


                </div>
            </div>


            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="ltop"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h5.jpg" alt="wvex1" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article ">

                            <p>Our inspiration for this house came from not one but several places - from movies to previous projects. </p>
                        </article>
                    </div>


                    <div className="rbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h6.jpg" alt="wvex1" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>We had to make sure that the place retained the symbol of its name, White Villa, in its design and decor.
                            </p>
                        </article>
                    </div>



                </div>
            </div>



            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="rtop"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h7.jpg" alt="wvex1" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>We stripped the place of any colour whatsoever, making the white stand out the most to create a sense of spaciousness.</p>
                        </article>
                    </div>

                    <div className="lbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h8.jpg" alt="wvex1" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>Our clients wanted the interiors to be peaceful yet somewhat subtly glamorous without being obvious.</p>
                        </article>
                    </div>


                </div>
            </div>


            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="ltop"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/h9.jpg" alt="wvex1" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article ">

                            <p>The final touch was given using the lights and patterned carpets in the hall of the villa which made the place look sleek at the entrance. </p>
                        </article>
                    </div>


                    <div className="rbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wv/v1.jpg" alt="wvex1" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>Our job was not just well done, but also well received by our client who said this was a "perfect modern villa".
                            </p>
                        </article>
                    </div>



                </div>
            </div>



            <Link to="/wooden-castle">
                <div className="section">
                    <h3 className="centerthis"><u>NEXT PROJECT</u></h3>
                </div>

            </Link>





        </>

    )
}

export default WhiteVille

